<template>
  <div class="app-logo" :style="style">
    <img v-if="webConfig.homeLogo" :src="logoSrc" @error="useDefaultLogo" style="display: none">
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: "AppLogo",
  data() {
    return {
      useDefault: false
    }
  },
  computed: {
    ...mapState(['webConfig']),
    logoSrc() {
      if (this.useDefault || !this.webConfig.homeLogo) {
        return '/images/home-logo.png';
      }
      return this.webConfig.homeLogo.startsWith('http') ? this.webConfig.homeLogo : '/api' + this.webConfig.homeLogo;
    },
    style() {
      return {
        backgroundImage: `url("${this.logoSrc}")`
      }
    }
  },
  methods: {
    useDefaultLogo() {
      this.useDefault = true;
    }
  }
};
</script>
<style lang='less'>
.app-logo {
  line-height: @layout-header-height;
  height: @layout-header-height;
  overflow: hidden;
  white-space: nowrap;
  transition: padding .3s;
  text-align: center;
  background-color: #3C72FF;

 
  background-size: 85%;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 16px;
}

.h-layout-sider-collapsed {
  .app-logo-text {
    display: none;
  }
}
</style>
